var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScheduleCalender(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.522,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    fill: "#FEF6F4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.522,
    y: 1.522,
    width: 47.955,
    height: 47.955,
    rx: 23.978,
    stroke: "#000",
    strokeWidth: 3.045
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#schedule-calender_svg__clip0_9378_64139)",
    stroke: "#E95832",
    strokeWidth: 3.265,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.119 16.793H17.88a2.177 2.177 0 00-2.177 2.177v15.238c0 1.202.975 2.176 2.177 2.176h15.238a2.177 2.177 0 002.177-2.176V18.97a2.177 2.177 0 00-2.177-2.177zM15.704 23.324h19.592M29.854 14.615v4.354M21.146 14.615v4.354"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "schedule-calender_svg__clip0_9378_64139"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12.439 12.439)",
    d: "M0 0h26.122v26.122H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/schedule-calender.1d39ab26.svg";
export { SvgScheduleCalender as ReactComponent };